<header class="buttons-container">
  <span
    *ngIf="design === 'modern'; else classicButtons"
    class="upper-buttons__buttons-container"
  >
    <ng-container *ngTemplateOutlet="buttonsTemplate"></ng-container>
  </span>
  <ng-template #classicButtons>
    <ng-container *ngTemplateOutlet="buttonsTemplate"></ng-container>
  </ng-template>
</header>

<ng-template #buttonsTemplate>
  <ng-container *ngIf="!configButtons || configButtons?.visible">
    <ng-container
      *ngFor="let btn of buttons; trackBy: trackById; let index = index"
    >
      <a
        (click)="onEvent(btn, $event)"
        (keyup)="onEvent(btn, $event)"
        *ngIf="btn.visible"
        [attr.aria-label]="btn.ariaLabel"
        [ngStyle]="{'font-size': btn.fontSize}"
        [sizeConfig]="{width: btn.size?.width, height: btn.size?.height}"
        [tabindex]="0"
        class="upper-button"
        ksSize
        role="button"
      >
        @if (btn.type === ButtonType.DOUBLE_SPEED && currentImage.type ===
        'video') {
        <span [title]="btn.title" class="double-speed"
          >{{ (videoSpeed$ | async) === 1 ? 'x2' : 'x1'}}</span
        >
        } @else if (btn.type === ButtonType.DOUBLE_SPEED && currentImage.type
        === 'audio') {
        <span [title]="btn.title" class="double-speed"
          >{{ (audioSpeed$ | async) === 1 ? 'x2' : 'x1'}}</span
        >
        } @else {
        <app-icon
          [icon]="btn.className.split(' ')"
          [iconName]="btn.iconName"
          [color]="design === 'modern' ? '#007bff' : undefined"
          [title]="btn.title"
          class="inside"
        ></app-icon>
        }
      </a>
    </ng-container>
  </ng-container>
</ng-template>
